<template>
  <div v-if="model && grids && templateData" class="tab-desglose p-2 desglose-host">
    <component :is="grids.TramitesGrid" :template-data="templateData" :show-reajuste-conceptos-buttons="true" @updated-factura="onUpdatedFactura" />
    <div class="mt-4 mb-4"></div>
    <component :is="grids.RappelsGrid" :template-data="templateData" />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import type { FacturaDetailModel } from "@api/api";
import {
  facturaDesgloseGridsKey,
  buildFacturaDesgloseTemplateData,
} from "./factura-desglose-injection";

const props = defineProps<{
  idFactura: string;
  model: FacturaDetailModel | null;
}>();

const emits = defineEmits(["updated-factura"]);

const grids = inject(facturaDesgloseGridsKey);

const templateData = computed(() =>
  props.model ? buildFacturaDesgloseTemplateData(props.idFactura, props.model) : null,
);

function onUpdatedFactura(): void {  
  emits("updated-factura");
}
</script>

<style lang="scss" scoped>

</style>
